export class PartnerPlatformConstants {
	public static readonly MODIFIED_DISPLAY_NAME_FIELD_NAME = 'modifiedDisplayName';
	public static readonly MODIFIED_DISPLAY_NAME_HAS_ERRORS = 'modifiedDisplayNameHasErrors';
	public static readonly ONE_HOLDING_ERROR = 'ONE_HOLDING_ERROR';
	public static readonly ZERO_HOLDINGS_ERROR = 'ZERO_HOLDINGS_ERROR';
	public static readonly EXCEEDS_MAX_HOLDING_PERCENTAGE_ERROR = 'EXCEEDS_MAX_HOLDING_PERCENTAGE_ERROR';
	public static readonly DUPLICATED_MORNINGSTAR_FUND_IDS_ERROR = 'DUPLICATED_MORNINGSTAR_FUND_IDS_ERROR';
	public static readonly TOO_MUCH_CASH_ERROR = 'TOO_MUCH_CASH_ERROR';
	public static readonly DEFAULT_INVALID_SECURITY_ERROR = 'DEFAULT_INVALID_SECURITY_ERROR';
}

export enum NotificationType {
	LOGIN_SUCCESS = 'LOGIN_SUCCESS',
	LOGIN_ERROR = 'LOGIN_ERROR',
	API_ERROR = 'API_ERROR',
	REIMPORT = 'REIMPORT',
	UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR',
	DUPLICATE_NAME = 'DUPLICATE_NAME'
}
export const DcrPrefixMapping = {
	LOGIN_SUCCESS: {
		dcrKey: 'PARTNER_LOGIN_SUCCESS_MESSAGE_',
		dcrValue: 'Authentication Successful'
	},
	LOGIN_ERROR: {
		dcrKey: 'PARTNER_LOGIN_ERROR_MESSAGE_',
		dcrValue: 'Authentication Failed'
	},
	API_ERROR: {
		dcrKey: 'PARTNER_API_ERROR_MESSAGE',
		dcrValue: `There was an error while retrieving data. Please try again later.`
	},
	UNAUTHORIZED_ERROR: {
		dcrKey: 'PARTNER_UNAUTHORIZED_ERROR_MESSAGE',
		dcrValue: `Your partner session has expired. Please login again.`
	},
	REIMPORT: {
		dcrKey: 'PARTNER_REIMPORT_PORTFOLIO',
		dcrValue: 'You have imported a portfolio that matches data already saved in our records. Your portfolio has been updated with the latest data.'
	},
	ONE_HOLDING_ERROR: {
		dcrKey: 'ONE_HOLDING_ERROR',
		dcrValue: 'This portfolio has only one holding, please remove.'
	},
	ZERO_HOLDINGS_ERROR: {
		dcrKey: 'ZERO_HOLDINGS_ERROR',
		dcrValue: 'This portfolio has no holdings, please remove.'
	},
	EXCEEDS_MAX_HOLDING_PERCENTAGE_ERROR: {
		dcrKey: 'EXCEEDS_MAX_HOLDING_PERCENTAGE_ERROR',
		dcrValue: 'This portfolio has a holding with >75% weight, please remove.'
	},
	DUPLICATED_MORNINGSTAR_FUND_IDS_ERROR: {
		dcrKey: 'DUPLICATED_MORNINGSTAR_FUND_IDS_ERROR',
		dcrValue: 'This portfolio has duplicate morningstar share classes, please remove.'
	},
	TOO_MUCH_CASH_ERROR: {
		dcrKey: 'TOO_MUCH_CASH_ERROR',
		dcrValue: 'This portfolio has cash and 1 or fewer holdings, please remove.'
	},
	DUPLICATE_NAME: {
		dcrKey: 'DUPLICATE_NAME',
		dcrValue: 'Some of your portfolios have names that already exist. Please go back and rename the portfolios.'
	}
};

export const InvalidPartnerPortfolioTypeMapping = {
	ONE_HOLDING_ERROR: {
		errorCode: 'min2Holdings',
		errorText: { key: DcrPrefixMapping.ONE_HOLDING_ERROR.dcrKey, text: DcrPrefixMapping.ONE_HOLDING_ERROR.dcrValue }
	},
	ZERO_HOLDINGS_ERROR: {
		errorCode: 'min2Holdings',
		errorText: { key: DcrPrefixMapping.ZERO_HOLDINGS_ERROR.dcrKey, text: DcrPrefixMapping.ZERO_HOLDINGS_ERROR.dcrValue }
	},
	EXCEEDS_MAX_HOLDING_PERCENTAGE_ERROR: {
		errorCode: 'weightOverMax',
		errorText: { key: DcrPrefixMapping.EXCEEDS_MAX_HOLDING_PERCENTAGE_ERROR.dcrKey, text: DcrPrefixMapping.EXCEEDS_MAX_HOLDING_PERCENTAGE_ERROR.dcrValue }
	},
	DUPLICATED_MORNINGSTAR_FUND_IDS_ERROR: {
		errorCode: 'duplicateMorningstarFundId',
		errorText: { key: DcrPrefixMapping.DUPLICATED_MORNINGSTAR_FUND_IDS_ERROR.dcrKey, text: DcrPrefixMapping.DUPLICATED_MORNINGSTAR_FUND_IDS_ERROR.dcrValue }
	},
	TOO_MUCH_CASH_ERROR: {
		errorCode: 'min3HoldingsCash',
		errorText: { key: DcrPrefixMapping.TOO_MUCH_CASH_ERROR.dcrKey, text: DcrPrefixMapping.TOO_MUCH_CASH_ERROR.dcrValue }
	}
};

